import { Button, Space, Table } from 'antd';
import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import UserApi from '../../functions/api/user/UserApi';
import TableUtils from '../../functions/TableUtils';
import CustomerViewButton from './CustomerViewButton';

class ListCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listUsers: [],
      listProc: [],
      searchText: '',
    };
  }

  async componentDidMount() {
    this.setState({ listUsers: await UserApi.getUserByRole(1) });
    this.setState({ listProc: await PartnerApi.getProcedures() });
  }

  handleChangeList = (list) => {
    this.setState({ listUsers: list });
  };

  render() {
    const { listUsers } = this.state;

    const columns = [
      {
        title: 'ID',
        dataIndex: 'user_acc_id',
        key: 'user_acc_id',
      },
      {
        title: 'Mã đối tác',
        dataIndex: 'user_part_id',
        key: 'user_part_id',
      },
      {
        title: 'Loại người dùng',
        dataIndex: 'user_role_id',
        key: 'user_role_id',
      },
      {
        title: 'Tên người dùng',
        dataIndex: 'user_acc_name',
        key: 'user_acc_name',
      },
      {
        title: 'Email',
        dataIndex: 'user_acc_emai',
        key: 'user_acc_emai',
        ...TableUtils.getColumnSearchProps('user_acc_emai'),
      },
      {
        title: 'Phone',
        dataIndex: 'user_acc_phon',
        key: 'user_acc_phon',
        ...TableUtils.getColumnSearchProps('user_acc_phon'),
      },
      {
        title: null,
        key: 'delete',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <Button
                type="default"
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/customer/detail/${record.user_acc_id}`
                  )
                }
              >
                Xem
              </Button>
              {!isEmpty(record.procedureImages) && (
                <CustomerViewButton record={record} />
              )}
            </Space>
          );
        },
      },
    ];

    return (
      <div>
        <Table
          columns={columns}
          rowKey="user_acc_id"
          dataSource={listUsers}
        ></Table>
      </div>
    );
  }
}

export default withRouter(ListCustomer);
